module.exports = __webpack_public_path__ + "media/images/my/bnr-mypage-line-ed2edb800d9d64970e366beb96a328f2.jpg";